import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { ExternalLink, Gift, Globe, MapPin } from 'lucide-react';
export interface OfferLink {
  label: string;
  url: string;
  primary?: boolean;
}
interface OfferCardProps {
  title: string;
  description: string;
  links: OfferLink[];
  type: 'regional' | 'trading' | 'generic';
  icon?: React.ReactNode;
  badge?: string;
}
export function OfferCard({
  title,
  description,
  links,
  type,
  icon,
  badge
}: OfferCardProps) {
  const getIcon = () => {
    if (icon) return icon;
    switch (type) {
      case 'regional':
        return <MapPin className="w-6 h-6 text-orange-500" data-id="element-19" />;
      case 'trading':
        return <Globe className="w-6 h-6 text-blue-500" data-id="element-20" />;
      default:
        return <Gift className="w-6 h-6 text-purple-500" data-id="element-21" />;
    }
  };
  return <Card className="h-full flex flex-col relative" data-id="element-22">
      {badge && <div className="absolute top-4 right-4 bg-orange-100 text-orange-700 text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-23">
          {badge}
        </div>}

      <div className="p-6 flex-1" data-id="element-24">
        <div className="w-12 h-12 rounded-lg bg-gray-50 flex items-center justify-center mb-4" data-id="element-25">
          {getIcon()}
        </div>

        <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-26">{title}</h3>
        <p className="text-gray-600 mb-6" data-id="element-27">{description}</p>
      </div>

      <div className="p-6 pt-0 mt-auto space-y-3" data-id="element-28">
        {links.map((link, index) => <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-29">
            <Button variant={link.primary ? type === 'trading' ? 'secondary' : 'primary' : 'outline'} fullWidth className="group" data-id="element-30">
              {link.label}
              <ExternalLink className="w-4 h-4 ml-2 opacity-70 group-hover:opacity-100" data-id="element-31" />
            </Button>
          </a>)}
      </div>
    </Card>;
}